module.exports = __webpack_public_path__ + "img/194.7b8e1397.jpg";